export default __webpack_public_path__ + "static/media/skeleton-mage-misprint.0afc4c43.jpg";